/* eslint-disable react/no-danger */
import React from 'react';
import { CDN_URL, getCdnImageUrl } from '@utils/cloudflare';
import ImageLoaded from '@components/common/ImageLoaded/ImageLoaded';
import Button from '../Button';

type CtaProps = {
  text: string;
  url: string;
  type: 'anchor' | 'link';
};

export type HeadingProps = {
  imageUrl: string;
  title: string;
  subtitle: string;
  cta: CtaProps;
};

export default function Heading({ imageUrl, title, subtitle, cta }: HeadingProps) {
  const imageFromCDN = getCdnImageUrl(720, imageUrl, CDN_URL);
  return (
    <div className="flex flex-col-reverse border-b border-rp-primary-redesign d:flex-row">
      <div className="w-full">
        <ImageLoaded url={imageFromCDN} layout="responsive" alt="hero image" />
      </div>
      <div className="flex flex-col gap-6 justify-center w-full px-4 py-10 d:px-12 d:py-0">
        <h1 className="text-32 leading-9 text-rp-neutral">{title}</h1>
        <p
          className="text-base max-w-424 text-rp-shadow"
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
        <Button
          size="lg"
          color="primary"
          fullScreen
          type={cta.type}
          href={cta.url}
          classes="block d:hidden"
        >
          {cta.text}
        </Button>
        <Button size="lg" color="primary" type={cta.type} href={cta.url} classes="hidden d:block">
          {cta.text}
        </Button>
      </div>
    </div>
  );
}
